import { trackSignUpButtonClicked } from '@/common/analytics';
import { CTAButton, type ButtonProps } from '@cointracker/styleguide';
import type React from 'react';

interface CallToActionButtonProps extends ButtonProps {
  href: string;
  buttonText: string;
  pageTitle: string;
  sectionName: string;
  sectionTitle: string;
  overrideHrefHandler?: () => void;
}
export const CallToActionButton = ({
  href,
  buttonText,
  pageTitle,
  sectionName,
  sectionTitle,
  children,
  className,
  overrideHrefHandler,
  ...props
}: CallToActionButtonProps) => {
  const trackSignup = () => {
    trackSignUpButtonClicked(buttonText, sectionName, sectionTitle, pageTitle);

    if (overrideHrefHandler) {
      overrideHrefHandler();
    } else if (href.startsWith('#')) {
      const id = href.replace(/^#/, '');
      document.getElementById(id)?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center',
      });
    } else {
      window.location.href = href;
    }
  };
  return (
    <CTAButton className={className} onClick={trackSignup} {...props}>
      {children}
    </CTAButton>
  );
};
